module.exports = __webpack_public_path__ + "static/media/ricepump-fitness.b284bc7f.jpg";